import styled from "styled-components"

export const Wrapper = styled.div`
  text-align: center;
`

export const Title = styled.div`
  font-weight: 400;
  font-size: 18px;
  line-height: 160%;
  color: #797199;
  margin-bottom: 16px;
`

export const Btns = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Btn = styled.a`
  margin-right: 36px;
  cursor: pointer;
  
  &:last-child {
    margin-right: 0;
  }
`
